import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WhatsAppUsageRoutes = defineRoute({
    record: {
        route: {
            path: "/whatsapp-usage",
            component: () => loadView(import("./WhatsAppUsageTable.vue")),
        },
    },
});
